import { useCurrentUser } from '../queries/use-current-user.js';
import { hasReportingRole } from './access.js';

export function useCanViewReports() {
  const { data: user, isLoading } = useCurrentUser();

  return { canViewReports: hasReportingRole(user), isLoading };
}
